module.exports = __webpack_public_path__ + "237891c60db3b0f8c2491b859fa15541.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/projekte/theater-2016.jpg
// module id = 819
// module chunks = 0